export const initialData = [
  {
    id: 0,
    title: "터미널",
    comment: "슬픈 영화인 줄 알았는데 코미디!",
    score: 4,
  },
  {
    id: 1,
    title: "사랑에 대한 모든 것",
    comment: "스티븐 호킹의 감동 실화ᅲᅲ",
    score: 5,
  },
  {
    id: 2,
    title: "터미네이터: 다크 페이트",
    comment: "내 취향은 아니었던 걸로...",
    score: 2,
  },
  {
    id: 3,
    title: "날씨의 아이",
    comment: "그럭저럭 볼만했던 영화 :)",
    score: 3,
  },
  {
    id: 4,
    title: "미나리",
    comment: "윤여정 선생님의 연기가 너무 멋졌다.",
    score: 5,
  },
];

export const options = [
  {
    id: 1,
    label: "5점",
    value: "5점",
  },
  {
    id: 2,
    label: "4점",
    value: "4점",
  },
  {
    id: 3,
    label: "3점",
    value: "3점",
  },
  {
    id: 4,
    label: "2점",
    value: "2점",
  },
  {
    id: 5,
    label: "1점",
    value: "1점",
  },
];
